var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02748 1.64693C4.97267 1.08078 6.05372 0.781594 7.15549 0.78125C8.07217 0.78071 8.97715 0.98708 9.80297 1.38498C10.6288 1.78288 11.3541 2.36204 11.925 3.0793C12.4958 3.79655 12.8974 4.6334 13.0998 5.52746C13.3021 6.42152 13.3001 7.34973 13.0938 8.2429C12.8876 9.13607 12.4823 9.97116 11.9084 10.6859C11.3344 11.4007 10.6066 11.9767 9.77901 12.371C8.95146 12.7653 8.04559 12.9677 7.12892 12.9631C6.36385 12.9593 5.60772 12.8115 4.89971 12.5287C3.36865 11.9832 2.5 11.0005 1.86596 9.889C1.39157 9.05691 1.11908 8.12279 1.07331 7.16212C1.02087 6.06159 1.26792 4.96745 1.78815 3.99623C2.30838 3.02501 3.0823 2.21309 4.02748 1.64693Z",
    fill: "#FF8B3E",
    fillOpacity: 0.2,
    stroke: "#FF8B3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23438 4.23438L7.23438 6.5",
    stroke: "#FF8B3E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23438 9.00781L7.23438 9.14777",
    stroke: "#FF8B3E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.76e791beec84841ff926029d3a8c6128.svg";
export { ForwardRef as ReactComponent };